import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { isDark, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-0.5 rounded bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 p-0.5 text-xs font-semibold">
      <button
        type="button"
        onClick={() => setTheme(false)}
        className={`flex items-center gap-1 px-2 py-1 rounded transition-colors ${
          !isDark
            ? 'bg-[#213A8F] text-white'
            : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-600'
        }`}
        data-testid="theme-light-btn"
        aria-label="Use light theme"
      >
        <Sun className="w-3 h-3" />
        Light
      </button>
      <button
        type="button"
        onClick={() => setTheme(true)}
        className={`flex items-center gap-1 px-2 py-1 rounded transition-colors ${
          isDark
            ? 'bg-[#213A8F] text-white'
            : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-600'
        }`}
        data-testid="theme-dark-btn"
        aria-label="Use dark theme"
      >
        <Moon className="w-3 h-3" />
        Dark
      </button>
    </div>
  );
};

export default ThemeToggle;

